export const mergeStateDataByPatients = (oldState, newState) => {
    const mergedState = {}
    Object.keys(newState).map((pId) => {
        mergedState[pId] = {...oldState[pId], ...newState[pId]}
    })
    return {...oldState, ...mergedState}
}